import React from 'react';
import {StaticQuery, graphql} from 'gatsby';

import Layout from '../components/layout';
import Library from '../components/library';

export default ({setTags}) => (
  <StaticQuery
    query={graphql`
      query getPosts {
        site {
          siteMetadata {
            title
            slogan
            siteUrl
            siteImage
            siteFavicon
          }
        }
        allMarkdownRemark(
          limit: 1000
          sort: {fields: [frontmatter___title], order: ASC}
        ) {
          categories: distinct(field: frontmatter___category)
          edges {
            node {
              excerpt(pruneLength: 250)
              html
              id
              frontmatter {
                path
                title
                desc
                excerpt
                category
                tags                
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <Layout
        isFrontPage={true}
        pageTitle={data.site.siteMetadata.title}
        description={data.site.siteMetadata.slogan}
        slogan={data.site.siteMetadata.slogan}
        siteTitle={data.site.siteMetadata.title}
        siteImage={data.site.siteMetadata.siteImage}
        siteFavicon={data.site.siteMetadata.siteFavicon}
        siteUrl={data.site.siteMetadata.siteUrl}
      >
        <Library
          posts={data.allMarkdownRemark.edges.map(({node}) => node)}
          categories={data.allMarkdownRemark.categories}
        />
      </Layout>
    )}
  />
);
